import { ReactComponent as Logomark } from '../images/logomark.svg';

/**
 * Oversized ArchiPro monogram that opens the standard article (Figma
 * 2354:55634). It is parked in the left margin, clear of the centred header
 * column, with its foot resting on the headline block. Decorative — the global
 * nav carries the linked logo — so it is hidden from assistive tech, and from
 * mobile, which has no design for it. Sizes in rem at the 1920 artboard (÷16),
 * base + md: only, matching the article-revamp siblings.
 *
 * It travels with the head, which holds its place on the screen while the
 * article scrolls in front of it — see `ArticleRevampPage`.
 */
export const RevampLogomark = () => (
    <Logomark
        aria-hidden="true"
        style={{ ['--fill-0' as string]: '#ffffff' }}
        className="pointer-events-none absolute top-[11.5rem] left-[3.1875rem] z-[1] hidden h-[10.375rem] w-[13.7235rem] md:block"
    />
);
